import { URLS } from 'config';
import { useCallback } from 'react';
import { generatePath, useHistory } from 'react-router-dom';
import { scrollToTop } from 'utils';
import { useEnquiryContext } from '../context';

export interface EnquiryWelcomeHook {
  onClick: () => void;
  tradingName: string;
  isLoading: boolean;
}

export default function useEnquiryWelcome(): EnquiryWelcomeHook {
  const { id, tradingName, isLoading } = useEnquiryContext();
  const { push } = useHistory();

  const onClick = useCallback(() => {
    if (!id) return;
    scrollToTop();
    push(generatePath(URLS.enquiryContactDetails, { id }));
  }, [id, push]);

  return { onClick, tradingName, isLoading };
}
